<template lang="pug">
.features.features-home
  .columns
    //- .column.is-one-third
      Slider(:slides="2")
        .result-general.notification.is-info.is-info-dark.has-text-left.slide
          .fs-16
            b Welcome!
          .mt-10
            p.small-content
              span Easily earn 
              b {{ coin || 'coins' }} 
              span by using you CPU, Graphics Card or ASIC!  
            p.small-content
              span Filter by your preferred mining hardware and follow the instructions to continue. If you are a beginner simply go to 
              router-link(to='/start') Get Started!
            p.small-content
              span Happy mining!

        content-creator-link.slide

    .column.is-full

      .tab-content-main
        .columns
          .column.is-two-thirds.has-text-left
            .start-info
              .title-mining 
                span Start 
                span.pink earn
                span ing 
                coin-switcher(
                  @selected="selectCoinFromSwitcher"
                )
              .info-block(v-if="isDelisted")
                p 
                  div
                    span.delisted-disclaimer This coin or token has been delisted and no further rewards will be credited.
                    br
                    span For more information kindly check the News section or our 
                    a(href="https://x.com/un_mineable", target="_blank")  official X feed.
              .info-block(v-if="!isDelisted")
                div
                  span All you need to get started is 
                  b your PC 
                  span  and 
                  span(v-if="'aeiou'.split('').indexOf(((coin && coin[0]) || '').toLowerCase()) > -1") an 
                  span(v-else) a 
                  b {{ coin }} 
                  span  address!
              .info-block(v-if="!isDelisted")
                template(v-if="isLoadingCoinData || chainsCoin.length === 1")
                  span Free payouts from  
                  b.w_min_amount(v-if="isLoadingCoinData")
                    i.fa.fa-circle-o-notch.fa-spin
                  b(v-else) 
                    span {{ chainsCoin[0].payment_threshold | thousandComma }} {{ coin }} ({{ chainsCoin[0].token_standard || chainsCoin[0].network }})

                template(v-else)
                  div
                    span Supported payment chains: 
                    b(v-for="(o, index) in chainsCoin") 
                      span {{ o.network }} ({{ o.token_standard }})
                      span(v-if="index !== chainsCoin.length - 1") , 
                    span .
                  div
                    span The minimum payment threshold is 
                    span(v-for="o, index in chainsCoin")
                      span(v-if="index === chainsCoin.length - 1")  and 
                      b {{ o.payment_threshold | thousandComma }} {{ coin }} 
                      span for the 
                      b {{ o.network }} 
                      span network
                      span(v-if="index < chainsCoin.length - 2") , 
                      span(v-if="index === chainsCoin.length - 1") .
                  div.mt-10
                    span Compatible payment networks can be switched at any time.
                .high_risk(v-if="highRiskCoin")
                  span {{ coin }} is a  
                  b highly volatile asset
                  span , daily mining rewards may be inconsistent due to large price fluctuations.
              .info-block.mt-20(v-if="newCoins.length || recentCoins.length > 1")
                span Or explore other coins or tokens:
                .newest-list
                  .new-coin.hint--bottom-right(v-for="i in recentCoins", :aria-label="i.name + ' (' + i.symbol + ')'", @click="selectNewCoin(i)", v-if="i.symbol != coin", :class="{ 'is-loading': loadingCoin === i.symbol }")
                    .new-tag(v-if="i.top === 1")
                    .new-tag.delisted(v-else-if="i.delisted === 1")
                    .new-coin-loading(v-if="loadingCoin === i.symbol")
                      i.fa.fa-circle-o-notch.fa-spin
                    .new-coin-logo
                      img(:src="i.logo")
                  .new-coin-separator(v-if="newCoins.length && recentCoins.length > 1")
                  .new-coin.hint--bottom-right(v-for="i in newCoins", :aria-label="i.name + ' (' + i.symbol + ')'", @click="selectNewCoin(i)", v-if="i.symbol != coin", :class="{ 'is-loading': loadingCoin === i.symbol }")
                    .new-tag(v-if="i.top === 1")
                    .new-tag.delisted(v-else-if="i.delisted === 1")
                    .new-coin-loading(v-if="loadingCoin === i.symbol")
                      i.fa.fa-circle-o-notch.fa-spin
                    .new-coin-logo
                      img(:src="i.logo")
                    //- .new-coin-name
                      span {{ i.symbol }}
                  .new-coin.view-all(@click="openCoinSwitcher")
                    span View all
                    i.fa.fa-arrow-right
          .column.is-one-third.start-controls

            template(v-if="selectedAlgorithm.isInOurEasyMiningApp || selectedAlgorithm.showInWizard")
              div.button.is-text.get-started-button(@click="$router.push('/start')") 
                b Get started 🚀 🧙‍♂️
              .small-desc-control.has-text-centered
                span Try the 
                span.w400 unMiner 
                span  desktop app or our guided setup!
              // .small-desc-control.has-text-centered
                span Try our easy 
                span.w400 guided setup!
              //- .small-desc-control For beginners and enthusiast miners
            template(v-if="!selectedAlgorithm.isInOurEasyMiningApp && !selectedAlgorithm.showInWizard && selectedAlgorithm.type === 'ASIC'")
              div.button.is-text.get-started-button(@click="$router.push('/support?search=ASIC')") 
                b Get started 🚀
              .small-desc-control Try our configuration tutorials & docs
        news.in-coin-news(
          :pinnedOnly="true"
        )
      .tab-content-main
        .columns
          .column.has-text-left
            .or-element
              .inner-or-element
                span Or 
                span.w400  manually setup 
                span your workers and point to one of our 
                span.w400  compatible algorithm pools

      algorithm-tabs(
        :selectedAlgorithm="selectedAlgorithm"
        @selected="selectAlgorithm"
      )

      .tab-content-main

        .columns
          .column.is-one-third.is-hidden-mobile
            PlatformStats
            news
            .info-miner.w100
              hr
              p If you have any issue, question or suggestion contact us here:
              br
              .mb-10
                div Email (Official Support Channel)
                a.social-link(href='mailto:support@unmineable.com')
                  b support@unmineable.com
              .mb-10
                div X (formerly Twitter)
                a.social-link(href='https://x.com/un_mineable', target='_blank')
                  b @un_mineable
              .mb-10
                div Instagram
                a.social-link(href='https://instagram.com/unminable', target='_blank')
                  b @unminable
              .mt-15
                span Beware of impersonators, we have no official Telegram or Discord channels.

          .column.is-one-third(:class="{'has-opacity': selectedAlgorithm.deactivated}") 
            .info-miner.w100
              .has-text-centered
                .starter-text.is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd
                  .mb-10(v-if="selectedAlgorithm.extraComment") {{ selectedAlgorithm.extraComment }}
                  template(v-if="selectedAlgorithm.symbolDesc != coin")
                    div 
                      span When you use the  
                      b {{ selectedAlgorithm.name }} 
                      span algorithm we automatically convert  
                      b {{ selectedAlgorithm.symbolDesc }} 
                      img(v-if="selectedAlgorithm.symbolDesc === selectedAlgorithm.symbol", :src="selectedAlgorithm.symbolLogo")
                      span  to  
                      b {{ coin }} 
                      img(:src="coinLogo", :alt="coin + ' logo'")
                      span  on each reward and credit it to your address.
                  template(v-else)
                    div 
                      span When you use the  
                      b {{ selectedAlgorithm.name }} 
                      span algorithm we automatically credit  
                      b {{ coin }} 
                      span  to your address
                .starter-text
                  span To get started with the  
                  b {{ selectedAlgorithm.name }} 
                  span  algorithm simply point your worker(s) to our pool:
                br
                .miner-pool(v-if="selectedAlgorithm")
                  .pool-box
                    .pool-desc {{ selectedAlgorithm.globalServer.description }}
                    .pool-url(@click="copyPoolToClipboard(selectedAlgorithm.globalServer.url)") {{ selectedAlgorithm.globalServer.url }}
                    .pool-url-alt(v-if="selectedAlgorithm.globalServer.alternativePorts && selectedAlgorithm.globalServer.alternativePorts.length > 0 && selectedAlgorithm.code !== 'kheavyhash'") 
                      span.w400 SSL Port
                      span(v-if="selectedAlgorithm.globalServer.sslPorts.length > 1") s 
                      span : 
                      template(v-for="p, index in selectedAlgorithm.globalServer.sslPorts")
                        span.pool-url-port(@click="copyPoolToClipboard('stratum+ssl://' + selectedAlgorithm.globalServer.url + ':' + p)") {{ p }}
                        span(v-if="index < selectedAlgorithm.globalServer.sslPorts.length - 2") , 
                        span(v-if="index === selectedAlgorithm.globalServer.sslPorts.length - 2")  & 
                    .pool-url-alt(v-if="selectedAlgorithm.globalServer.sslPorts && selectedAlgorithm.globalServer.sslPorts.length > 0 && selectedAlgorithm.code !== 'kheavyhash'") 
                      span.w400 TCP Port
                      span(v-if="selectedAlgorithm.globalServer.alternativePorts.length > 1") s 
                      span : 
                      template(v-for="p, index in selectedAlgorithm.globalServer.alternativePorts")
                        span.pool-url-port(@click="copyPoolToClipboard('stratum+tcp://' + selectedAlgorithm.globalServer.url + ':' + p)") {{ p }}
                        span(v-if="index < selectedAlgorithm.globalServer.alternativePorts.length - 2") , 
                        span(v-if="index === selectedAlgorithm.globalServer.alternativePorts.length - 2")  & 
                    .pool-url-alt(v-if="selectedAlgorithm.globalServer.highDiffPorts && selectedAlgorithm.globalServer.highDiffPorts.length > 0") 
                      span.w400 High Diff Port
                      span(v-if="selectedAlgorithm.globalServer.highDiffPorts.length > 1") s 
                      span : 
                      template(v-for="p, index in selectedAlgorithm.globalServer.highDiffPorts")
                        span.pool-url-port(@click="copyPoolToClipboard('stratum+'+ (p.ssl ? 'ssl' : 'tcp') + '://' + selectedAlgorithm.globalServer.url + ':' + p.port)") {{ p.port }} ({{ p.ssl ? 'SSL' : 'TCP' }})
                        span(v-if="index < selectedAlgorithm.globalServer.highDiffPorts.length - 2") , 
                        span(v-if="index === selectedAlgorithm.globalServer.highDiffPorts.length - 2")  & 
                    .pool-url-alt(v-if="selectedAlgorithm.globalServer.extraPorts && selectedAlgorithm.globalServer.extraPorts.length > 0", v-for="ep in selectedAlgorithm.globalServer.extraPorts") 
                      span.w400 {{ ep.name }}: 
                      template(v-for="p, index in ep.ports")
                        span.pool-url-port(@click="copyPoolToClipboard('stratum+'+ (p.ssl ? 'ssl' : 'tcp') + '://' + selectedAlgorithm.globalServer.url + ':' + p.number)") 
                          span {{ p.number }} 
                          span(v-if="ep.showType") ({{ p.ssl ? 'SSL' : 'TCP' }})
                        span(v-if="index < ep.ports.length - 2") , 
                        span(v-if="index === ep.ports.length - 2")  & 
                  .pool-selection
                    span By using the global server we will auto select the closest server to your location, however you can still  
                    a.toggle-global-server(href='#', @click.prevent="isShowingAlternativeServers = !isShowingAlternativeServers") manually set a server if you want
                  .pool-global-selection(v-if="isShowingAlternativeServers")
                    .pool-box(v-for="o in selectedAlgorithm.alternativeServers")
                      .pool-desc {{ o.description }}
                      .pool-url(@click="copyPoolToClipboard(o.url)") {{ o.url }}
                      .pool-url-alt(v-if="o.sslPorts && o.sslPorts.length > 0 && selectedAlgorithm.code !== 'kheavyhash'") 
                        span.w400 SSL Port
                        span(v-if="o.sslPorts.length > 1") s 
                        span : 
                        template(v-for="p, index in o.sslPorts")
                          span.pool-url-port(@click="copyPoolToClipboard('stratum+ssl://' + o.url + ':' + p)") {{ p }}
                          span(v-if="index < o.sslPorts.length - 2") , 
                          span(v-if="index === o.sslPorts.length - 2")  & 
                      .pool-url-alt(v-if="o.alternativePorts && o.alternativePorts.length > 0 && selectedAlgorithm.code !== 'kheavyhash'") 
                        span.w400 Alternative Port
                        span.w400(v-if="o.alternativePorts.length > 1") s 
                        span : 
                        template(v-for="p, index in o.alternativePorts")
                          span.pool-url-port(@click="copyPoolToClipboard('stratum+tcp://' + o.url + ':' + p)") {{ p }}
                          span(v-if="index < selectedAlgorithm.globalServer.alternativePorts.length - 2") , 
                          span(v-if="index === selectedAlgorithm.globalServer.alternativePorts.length - 2")  & 
                      .pool-url-alt(v-if="o.highDiffPorts && o.highDiffPorts.length > 0 && selectedAlgorithm.code !== 'kheavyhash'") 
                        span.w400 High Diff Port
                        span(v-if="o.highDiffPorts.length > 1") s 
                        span : 
                        template(v-for="p, index in o.highDiffPorts")
                          span.pool-url-port(@click="copyPoolToClipboard('stratum+' + (p.ssl ? 'ssl' : 'tcp') + '://' + o.url + ':' + p.port)") {{ p.port }} ({{ p.ssl ? 'SSL' : 'TCP' }})
                          span(v-if="index < o.highDiffPorts.length - 2") , 
                          span(v-if="index === o.highDiffPorts.length - 2")  & 
                      .pool-url-alt(v-if="o.extraPorts && o.extraPorts.length > 0", v-for="ep in o.extraPorts") 
                        span.w400 {{ ep.name }}: 
                        template(v-for="p, index in ep.ports")
                          span.pool-url-port(@click="copyPoolToClipboard('stratum+'+ (p.ssl ? 'ssl' : 'tcp') + '://' + o.url + ':' + p.number)") 
                            span {{ p.number }} 
                            span(v-if="ep.showType") ({{ p.ssl ? 'SSL' : 'TCP' }})
                          span(v-if="index < ep.ports.length - 2") , 
                          span(v-if="index === ep.ports.length - 2")  & 

                br
                span Be sure to set the user field with the coin you are mining, your address and your worker name:
                br
                br
                br
                .miner-pool#informative-text 
                  span.hint--top-left.hint--always(
                    aria-label='The asset symbol'
                    v-if="informativeDivHeight > 80"
                  ) {{ coin }}
                  span.hint--bottom-right.hint--always(
                    aria-label='The asset symbol'
                    v-else
                  ) {{ coin }}
                  b :
                  span.hint--top-right.hint--always(:aria-label="'Your ' + coin + ' address'") YourAddress
                  b .
                  span.hint--bottom.hint--always(aria-label='A worker name is required!') YourWorkerName

                br
                br
                span ...and start mining!
                br
                br

                .referral-template-home
                  template(v-if="referralCode")
                    span You have been  
                    b  referred by another miner!  
                    span   you can 
                    u  lower your mining fee to 0.75% 
                    span , just add the following code after your worker name, separated by a  
                    b  #  
                    span  symbol:
                  template(v-else)
                    span If you have a  
                    b  Referral Code  
                    span   you can 
                    u  lower your mining fee to 0.75% 
                    span , just add it after your worker name, separated by a  
                    b  #  
                    span  symbol:
                  br
                  br
                  .miner-pool 
                    span.hint--top.pointable(aria-label='The asset symbol') {{ coin }}
                    b :
                    span.hint--top.pointable(:aria-label="'Your ' + coin + ' address'") Address
                    b .
                    span.hint--top.pointable(aria-label='A worker name is required!') Worker
                    b #
                    span.hint--top.pointable.memo-(aria-label='An optional Referral code!') {{ referralCode || 'referral-code' }}
                  br
                  span (*) The referral code won't change your worker's name in your stats page.
                  br
                  br
                  span Learn more about  
                  b
                    router-link(to='/referrals')  the commissions and benefits of having / sharing a referral code here!
                template(v-if="isMemoCoin")
                  br
                  .memo-template-home
                    span If you are  
                    b  mining to an exchange or need to set a MEMO or TAG  
                    span  you must add it after your address:
                    br
                    br
                    .miner-pool
                      span.hint--top.pointable(aria-label='The asset symbol') {{ coin }}
                      b :
                      span.hint--top.pointable(:aria-label="'Your ' + coin + ' address'") YourAddress
                      b :
                      span.hint--top.pointable.memo-(:aria-label="'Your ' + coin + ' memo or tag'") YourMemo
                      b .
                      span.hint--top.pointable(aria-label="A worker name is required!") YourWorkerName

          .column.is-one-third
            .info-miner.w100
              div
                template.mb-13(v-if="selectedAlgorithm.isInOurEasyMiningApp")
                  p.has-text-left
                    span You can get started by using our easy mining desktop app:

                  // to="/support/article/how-to-setup-our-easy-mining-app"
                  .guides.mb-13
                    router-link.mining-guide(
                      to="/miner"
                    )
                      .flex-1
                        span How to setup  
                        b.w400 Our easy mining app
                      span.icon
                        i.fa.fa-external-link

                template(v-if="selectedAlgorithm.showInWizard")
                  p.has-text-left
                    span You can also try our easy guided setup for third party apps:

                  .guides
                    router-link.mining-guide(
                      to="/wizard"
                    )
                      .flex-1
                        span Get started with 
                        b.w400 our Guided Setup
                      span.icon
                        i.fa.fa-external-link

                p.has-text-left(:class="{'mt-13': selectedAlgorithm.showInWizard}")
                  span(v-if="selectedAlgorithm.showInWizard") Or follow 
                  span(v-else) You can also get started by following 

                  span(v-if="selectedAlgorithm.guides.length > 1") one of our more advanced setup guides:
                  span(v-else) our more advanced setup guide:

                .guides
                  router-link.mining-guide(
                    v-for="o, index in selectedAlgorithm.guides"
                    :key="'guide'+index"
                    :to="o.relativeUrl"
                  )
                    .flex-1
                      span Get started with 
                      b.w400  {{ o.name }}
                    span.icon
                      i.fa.fa-external-link

                .search-coin-home.is-hidden-touch
                  hr
                  p Enter your address to check your stats:
                  br
                  .field.field-address.field-address-home.has-addons
                    .control.is-medium.is-expanded
                      input.input.is-medium.address_input_home(
                        type="text", 
                        :placeholder="'Your ' + coin + ' address'", 
                        v-model="address"
                        @keyup.enter="goToAddress"
                      )
                    .control.find_address_home
                      a.button.is-success.is-medium(
                        @click="goToAddress"
                      )
                        i.fa.fa-search

                  .label-calculate.mt-5(v-if="isMemoCoin") 
                    span If you are using a payment tag or memo search by: 
                    span.w400  YourAddress
                    b.margin-memo-text.w400
                    span.w400 YourMemo

                news.is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd

                hr

                calculator(
                  ref="calculator"
                  :selectedAlgorithm="selectedAlgorithm"
                  :coin="coin"
                )

              .info-miner.w100.is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd
                hr
                p If you have any issue, question or suggestion contact us here:
                br
                .mb-10
                  div Email (Official Support Channel)
                  a.social-link(href='mailto:support@unmineable.com')
                    b support@unmineable.com
                .mb-10
                  div X (formerly Twitter)
                  a.social-link(href='https://x.com/un_mineable', target='_blank')
                    b @un_mineable
                .mb-10
                  div Instagram
                  a.social-link(href='https://instagram.com/unminable', target='_blank')
                    b @unminable
                .mt-15
                  span Beware of impersonators, we have no official Telegram or Discord channels.

</template>

<script>
import { apiGet, debounce } from '../util/general'
import News from '../components/c_news'
import Calculator from '../components/c_calculator'
import AlgorithmTabs from '../components/c_tab_algorithm_select'
import ContentCreatorLink from '../components/c_content_creator_link'
import PlatformStats from '../components/c_platform_stats'
import Slider from '../components/c_slider'
import CoinSwitcher from '../components/c_coin_switcher'
export default {
  name: 'view_coin',
  components: {
    News,
    Calculator,
    'algorithm-tabs': AlgorithmTabs,
    'content-creator-link': ContentCreatorLink,
    PlatformStats,
    Slider,
    CoinSwitcher
  },
  data() {
    return {
      showAlwaysReload: true,
      isLoadingRewardData: true,
      isLoadingCoinData: true,
      highRiskCoin: false,
      isDelisted: false,
      address: '',
      chainsCoin: [],
      isMemoCoin: false,
      selectedAlgorithm: {},
      isShowingAlternativeServers: false,
      informativeDivHeight: 0,
      listOfAlgorithms: [],
      loadingCoin: ''
    }
  },
  computed: {
    showCoinSwitcher() {
      return this.$store.getters.showCoinSwitcher
    },
    referralCode() {
      return this.$store.getters.ref
    },
    coin() {
      return this.$store.getters.coinSymbol
    },
    coinName() {
      return this.$store.getters.coinData.name
    },
    coinLogo() {
      return this.$store.getters.coinData.logo
    },
    noPOWMessage() {
      let vm = this
      return ['BTC', 'BTG', 'DASH', 'DOGE', 'ETC', 'ETH', 'LTC', 'RVN', 'XMR', 'BCH', 'SC', 'SKY', 'VIA'].indexOf(vm.coin) > -1
    },
    algos() {
      return this.$store.getters.algos
    },
    lastAlgorithms() {
      return this.$store.getters.lastAlgorithms
    },
    newCoins() {
      return this.$store.getters.newCoins
    },
    recentCoins() {
      return this.$store.getters.recentCoins
    }
  },
  async created() {
    let vm = this
    vm.$store.dispatch('setPageSelected', 'start')
    vm.$store.dispatch('validateVersion')
    // initialize list of algorithms
    let listOfAlgorithms = []
    let algorithmQuery = vm.$route.query.algorithm
    let algorithmQueryExists = false
    let selectedAlgorithm = {}

    for (let i = 0; i < vm.algos.length; i++) {
      let obj = {
        code: vm.algos[i].code,
        name: vm.algos[i].name,
        symbol: vm.algos[i].symbol,
        longName: vm.algos[i].longName,
        symbolLogo: vm.algos[i].symbolLogo,
        symbolDesc: vm.algos[i].symbolMerged || vm.algos[i].symbol,
        type: vm.algos[i].type,
        typeCode: vm.algos[i].typeCode,
        deactivated: vm.algos[i].deactivated,
        miningVia: vm.algos[i].miningVia,
        minimumVramRequirement: vm.algos[i].minimumVramRequirement,
        unitOfMeasurement: vm.algos[i].unitOfMeasurement,
        extraComment: vm.algos[i].extraComment,
        new: vm.algos[i].new,
        globalServer: JSON.parse(JSON.stringify(vm.algos[i].globalServer)),
        alternativeServers: JSON.parse(JSON.stringify(vm.algos[i].alternativeServers)),
        guides: JSON.parse(JSON.stringify(vm.algos[i].guides)),
        lastReward: '',
        lastRewardChanged: false,
        averageReward: '',
        warningMessage: vm.algos[i].warningMessage,
        warningDotMessage: vm.algos[i].warningDotMessage,
        showInWizard: vm.algos[i].showInWizard,
        preUnitOfMeasurement: vm.algos[i].preUnitOfMeasurement,
        minimumUnitOfMeasurement: vm.algos[i].minimumUnitOfMeasurement,
        minCalculatorUnit: vm.algos[i].minCalculatorUnit,
        maxCalculatorUnit: vm.algos[i].maxCalculatorUnit,
        defaultCalculatorUnit: vm.algos[i].defaultCalculatorUnit,
        isInOurEasyMiningApp: vm.algos[i].isInOurEasyMiningApp
      }

      if (algorithmQuery && obj.code === algorithmQuery) {
        algorithmQueryExists = true
        selectedAlgorithm = obj
      }

      listOfAlgorithms.push(obj)
    }

    vm.listOfAlgorithms = listOfAlgorithms

    if (algorithmQueryExists) vm.selectedAlgorithm = selectedAlgorithm
    else {
      let lastAlgorithms = vm.lastAlgorithms
      if (lastAlgorithms && lastAlgorithms.length > 0) {
        let lastAlgo = lastAlgorithms[0]
        vm.selectedAlgorithm = vm.listOfAlgorithms.find(element => element.code === lastAlgo)
      } else {
        vm.selectedAlgorithm = vm.listOfAlgorithms[0]
      }
    }

    if (algorithmQuery && !algorithmQueryExists) {
      vm.$router.push(vm.$route.path)
    }

    vm.updateMetaTags()
  },
  mounted() {
    let vm = this
    window.addEventListener('resize', vm.getDimensions);

    let element = document.getElementById('informative-text')
    if (element) {
      vm.informativeDivHeight = element.getClientRects()[0].height
    }

    let intervalAux = setInterval(function () {
      if (vm.coin) {
        if (vm.$route.query.coin && vm.$route.query.coin !== vm.coin) {
          // re-set the coin
          vm.$store.dispatch('setCoin', { coin: vm.$route.query.coin }).then(() => {
          }).finally(() => {
            vm.$store.dispatch('addToCoinList', vm.coin)
            vm.updateMetaTags()
            vm.fetchCoinData()
          })
        } else {
          vm.$store.dispatch('addToCoinList', vm.coin)
          vm.updateMetaTags()
          vm.fetchCoinData()
        }
        clearInterval(intervalAux)
      }
    }, 100)

    vm.initializeGlobalTotals()

    // For getting the new coins category
    vm.$store.dispatch('getCoins')
  },
  unmounted() {
    window.removeEventListener('resize', this.getDimensions);
  },
  methods: {
    setTitle (title) {
      document.title = title
      const metaTitle = document.querySelector('head meta[property="og:title"]');
      metaTitle.setAttribute('content', title);
    },
    selectCoinFromSwitcher(o) {
      let vm = this
      vm.updateMetaTags()
      vm.fetchCoinData()
    },
    updateMetaTags() {
      let vm = this
      let title = ''

      if (!vm.coinName) {
        vm.$store.dispatch('setCoin', { coin: vm.coin }).then(() => {
          title = 'unMineable - ' + vm.coinName + ' (' + vm.coin + ') mining pool - Earn ' + vm.coin + ' with your Graphics Cards, CPU & ASICs'
          vm.setTitle(title)
        }).finally(() => {
        })
      } else {
        title = 'unMineable - ' + vm.coinName + ' (' + vm.coin + ') mining pool - Earn ' + vm.coin + ' with your Graphics Cards, CPU & ASICs'
        vm.setTitle(title)
      }
    },
    initializeGlobalTotals() {
      var vm = this
      var url = '/v5/pool'
      var obj = {}
      apiGet(vm, url, obj, function (data) {
        let summary = data.data.summary
        vm.$store.dispatch('manuallySetGloballyTotals', { totalWorkers: summary.past_24hr_workers, totalPaid: summary.total_paid_btc, totalMiners: summary.past_24hr_miners })
      }, function (err) {
        console.error('Error:', err.message)
      })
    },
    getDimensions() {
      let vm = this
      let element = document.getElementById('informative-text')
      if (element) {
        vm.informativeDivHeight = element.getClientRects()[0].height
      }
    },
    fetchCoinData() {
      var vm = this
      vm.isLoadingCoinData = true
      var url = '/v5/coin/' + vm.coin
      var obj = {}
      apiGet(vm, url, obj, function (data) {
        let chains = data.data.chains
        vm.chainsCoin = chains
        vm.highRiskCoin = data.data.high_risk
        vm.isDelisted = data.data.delisted
        vm.isMemoCoin = !!data.data.regex_memo
      }, function (err) {
        console.error('Error:', err.message)
        vm.$store.dispatch('notifyError', err.message)
      }, function () {
        vm.isLoadingCoinData = false
      })
    },
    copyPoolToClipboard(text) {
      let vm = this
      const clipboardData = event.clipboardData || window.clipboardData || navigator.clipboard;
      clipboardData.writeText(text);
      vm.$store.dispatch('notifySuccess', 'The pool have been copied!')
    },
    goToAddress() {
      let vm = this
      if (vm.address) {
        vm.address = vm.address.trim()
        vm.$router.push('/address/' + vm.address + '?coin=' + vm.coin)
      }
    },
    setLastReward(algorithm, data) {
      let vm = this
      for (var i = 0; i < vm.listOfAlgorithms.length; i++) {
        if (vm.listOfAlgorithms[i].code === algorithm) {
          vm.listOfAlgorithms[i].lastReward = data * 1000
          vm.listOfAlgorithms[i].lastRewardChanged = true
          setTimeout(function () {
            vm.listOfAlgorithms[i].lastRewardChanged = false
          }, 310)
          break
        }
      }
    },
    selectAlgorithm(code) {
      let vm = this

      let selected = vm.listOfAlgorithms.find(element => element.code === code)

      vm.selectedAlgorithm = selected
      if (!vm.selectedAlgorithm.deactivated) {
        vm.debounceCalculatorCall()
      }

      // vm.$router.push(vm.$route.path + `?algorithm=${vm.selectedAlgorithm.code}`)
      vm.$router.push({query: { ...vm.$route.query, algorithm: vm.selectedAlgorithm.code }})
      // vm.$route.query.algorithm = vm.selectedAlgorithm.code;
    },
    selectNewCoin (o) {
      let vm = this
      vm.loadingCoin = o.symbol
      vm.$store.dispatch('setCoin', { coin: o.symbol }).then(() => {
        vm.$store.dispatch('addToCoinList', o.symbol)
        // vm.$store.dispatch('addToCoinList', vm.coin)
        vm.updateMetaTags()
        vm.fetchCoinData()
        vm.loadingCoin = ''
      }).catch((err) => {
        console.error(err)
      })
    },
    openCoinSwitcher () {
      let vm = this
      document.querySelector('html').style.overflow = 'hidden'
      vm.$store.dispatch('openCoinSwitcher')
    },
    debounceCalculatorCall: debounce(function (e) {
      this.$refs.calculator.populateUnits()
      this.$refs.calculator.calculateProfitability()
    }, 500)
  }
}
</script>

<style lang="stylus" scoped>

.delisted-disclaimer
  color: #d94848;
  font-weight: 700;

.general-main-info-algo
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: solid 1px #dbdbdb;
  text-align: left;
  font-size 15px
  .last-rewarded
    b
      font-weight: 400
  .last-rewarded >>> b
    font-weight: 400

.referral-template-home
  background: #f4fff7;
  padding: 25px;
  font-weight: 400;
  .miner-pool
    border-color: #76a57e;

.pool-box
  margin-bottom: 10px
  .pool-url
    cursor pointer
    display: inline-block;
    font-size 19px
    &:hover
      background: #f5f5f5;
      border-radius: 5px;
  .pool-url-alt
    font-size: 12px;
    color: #676767;
  .pool-desc
    font-size: 10px;
    color: #676767;
  
  .pool-url-port
    cursor pointer
    padding: 0px 2px;
    &:hover
      background: #f5f5f5;
      border-radius: 5px;

.pool-selection
  font-size: 10px;
  font-weight: normal;

.or-element
  text-align: center;
  padding: 15px 0px 30px 0px;
  position relative
  .inner-or-element
    display: inline-block;
    background #fff
    position relative
    padding 0px 10px
    margin: 0px 25px;
  &:before
    content: ""
    width 100%
    height 2px
    background #e3e3e3
    position absolute
    top: calc(50% - 5px);
    left 0px

.starter-text
  font-size 15px
  padding: 10px 0px;
  span, b, img
    vertical-align middle
  img
    width: 16px;
    margin: 0px 2.5px
.pool-global-selection
  margin-top: 15px;

.start-info
  padding 10px
  .title-mining
    font-size: 2.1rem;
    // margin-bottom: 5px;
    margin-bottom: 15px;
    font-weight: 600;
    span, img
      vertical-align: middle;
    .coin-symbol
      font-weight 700
    img
      margin: 0px 10px;
      width: 28px;
      min-width: 28px;
      display: inline-block;
      vertical-align: middle;
  .info-block
    font-size 14px
.start-controls
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  .small-desc-control
    font-size: 13px;
    padding: 7.5px 0px;
    max-width 250px
.guides
  margin-top 10px

.mining-guide
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  padding: 10px 10px;
  border: solid 1px #ccc;
  margin-top: 5px;
  border-radius: 5px;
  cursor: pointer
  color #000
  i
    float: right;
    line-height: 18px;
  &:hover
    border solid 1px #8e8e8e

.field-address-home
  width: 250px !important;
  margin: auto;
  margin-bottom 0.75rem

.memo-
  color: #292929 !important

.margin-memo-text
  margin: 0px 1.5px;

.get-started-button
  background-color #b6ffb6
  text-decoration none
  padding: 0 25px
  display: flex;
  justify-content: center;
  align-items: center;  height 50px
  margin-top 10px
  height 46px
  // font-size 15px
  font-size: 18px;
  height: 55px;
  padding: 0 50px;
  box-shadow: 0 0 1px 0px #8fb88f;
  &:hover
    background-color #b6ffb6

.columns.columns-no-space
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;

.newest-list
  padding-top: 7.5px;
  .new-coin-separator
    vertical-align: middle;
    width: 2px;
    background: #d5d5d5;
    display: inline-block;
    height: 32px;
    margin-right: 7.5px;
    border-radius: 14px;
  .new-coin
    cursor pointer
    display: inline-block;
    text-align: center;
    margin-right: 7.5px;
    margin-top: 10px;
    padding: 10px 15px;
    border-radius: 10px;
    position: relative;
    .new-tag
      position: absolute;
      background: #b6ffb6;
      bottom: -6px;
      right: -3px;
      border-radius: 2px;
      font-size: 7px;
      font-weight: 700;
      padding: 2px 5px;
      &:after
        content "New"
      &.delisted
        background: #fff5b6;
        &:after
          content "Delisted"
    &.is-loading
      .new-coin-logo img
        opacity .3
    &:not(.view-all)
      background: #f5f5f5;
    &.view-all
      font-weight: 700;
      font-size: 12px;
      border: none;
      padding: 10px 5px;
      i
        margin-left 7.5px
    .new-coin-loading
      position: absolute;
      top: calc(50% - 9px);
      left: calc(50% - 7px);
    .new-coin-logo
      text-align: center;
      img
        display: inline-block;
        vertical-align: middle;
        width: 20px;
    .new-coin-name
      margin-top 5px
      text-align: center;
      font-weight: 700;
      font-size: 12px;
      color: #5d5d5d;

@media (max-width: 550px)
  .start-info .title-mining
    margin-bottom 25px
  .pool-box .pool-url
    font-size 18px
  .get-started-button
    font-size: 20px;
    height: 60px;
    padding: 0 50px;
  .new-coin-separator
    display none !important
  .newest-list .new-coin .new-tag
    bottom: -3px;
    padding: 0px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    &:after
      content ""

html.dark, body.dark

  .start-info .title-mining .coin-symbol
    color #000
  .start-info, .small-desc-control
    color #fff
  .or-element
    .inner-or-element
      transition all .3s ease
      background: #2c2c2c
      color: #fff;
    &:before
      transition all .3s ease
      background: #4f4f4f;
  .newest-list
    .new-coin-loading
      color #fff
  .newest-list .new-coin:not(.view-all)
    background: #4a4a4a;
  .newest-list .new-coin .new-tag
    color: #000;
  .new-coin-separator
    background #808080

</style>



// WEBPACK FOOTER //
// View_Coin.vue?10671ac2